export enum PAGES {
	HOME = 'seller-manager',
	UTILS = 'seller-manager.utils',
}
